import { render, staticRenderFns } from "./EditableTextarea.vue?vue&type=template&id=73f53720&scoped=true&"
import script from "./EditableTextarea.vue?vue&type=script&lang=ts&"
export * from "./EditableTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f53720",
  null
  
)

export default component.exports